// extracted by mini-css-extract-plugin
export default {"container":"CompaniesManagement_container__Px8XM","companies":"CompaniesManagement_companies__M6NQL"};